$(document).ready(function () {
  $('.product_details_button').click(function (e) { 
    e.preventDefault();
      $('.product_info_collapse_det').toggle(500);
    $('.product_details_button').toggleClass('active');
  });

 $('.delivery_returns_button').click(function (e) { 
    e.preventDefault();
      $('.delivery_returns_det').toggle(500);
    $('.delivery_returns_button').toggleClass('active');
  });


$('#tabs li>span:not(:first)').addClass('tab_inactive');
$('.tab_container').hide();
//$('.container:first').show();
    
$('#tabs li>span').click(function(){
    var t = $(this).attr('id');
  if($(this).hasClass('tab_inactive')){ //this is the start of our condition 
    $(this).parents('ul').addClass('tabIsopen');
    $(this).parents('ul').attr('open-tab',t);
    $('#tabs li>span').addClass('tab_inactive');           
    $(this).removeClass('tab_inactive');
    
    $('.tab_container').hide();
    $('#'+ t + 'C').fadeIn('slow');
 }else{
      $('#tabs li>span').addClass('tab_inactive');  
    $('.tab_container').hide();
    $(this).parents('ul').removeClass('tabIsopen');
     $(this).parents('ul').attr('open-tab', 'close');
 }
});
  
  
  $('.navIcon').click(function (e) { 
    e.preventDefault();
    $('.side_nav').toggleClass('slide_openNav');
    $(this).toggleClass('navIconOpen');
    
  });

  
  $(window).scroll(function () { 
    //change header color
	var color_background2 =  $('.color-background-2').length !== 0  ? $('.color-background-2').offset().top-30 : 0 ;
    if($(window).scrollTop() > color_background2){
      $('header.header').addClass('activOherColor');
    } else{
      $('header.header').removeClass('activOherColor');
    } 

  //add to cart sticky
  var add_to_cart_posit_bottom = $(window).height() - $('.product-form__buttons').outerHeight();
   var add_to_cart_position = $('.mng_productInfo .product-form__buttons').length !== 0 ? $('.mng_productInfo .product-form__buttons').offset().top-add_to_cart_posit_bottom : 0;
    if($(window).scrollTop() > add_to_cart_position){
      $('.mng_productInfo .product-form__buttons').addClass('mob_cart_sticky');
    }else{
      $('.mng_productInfo .product-form__buttons').removeClass('mob_cart_sticky');
    }
    
  }).trigger('resize') ;


$('.carousel-cell img').each((index,item)=>{
   $(item).parent().css('background-color',$(item).attr('alt'))
})
/* $(document).on('change','input[name=Color]',function(e){
    $('.flickity-slider .carousel-cell').css('background-color',$(this).val())
})*/
  


});